import { render } from "./index.vue?vue&type=template&id=359dcbcd&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=359dcbcd&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359dcbcd"]])

export default __exports__